import _ from 'lodash'

import { renderTemplate } from 'src/lib/util'

const TooltipTemplate =
  '<span style="font-size: 12px; font-weight: 600;">{title}</span>' +
  '<div class="chart__tooltip-advanced__datasets">{body}</div>'

const TooltipBodyTemplate =
  '<div class="chart__tooltip-advanced__dataset">' +
  '<div class="chart__tooltip-advanced__dataset__swatch" style="background-color: {bgColor}"></div>' +
  '<div class="chart__tooltip-advanced__dataset__text">{label}: <span>{value}</span></div>' +
  '</div>'

export const customTooltip = (tooltip, data) => {
  // Tooltip Element
  var parent = document.getElementById('c-level-graph')
  var lineParent = document.getElementById('graph-line-parent')
  var tooltipEl = document.querySelector('.chart__tooltip-advanced')
  var hoverLineEl = document.querySelector('.chart__hover-line')

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.classList.add('chart__tooltip-advanced')
    hoverLineEl = document.createElement('div')
    hoverLineEl.classList.add('chart__hover-line')
    parent.appendChild(tooltipEl)
    lineParent.appendChild(hoverLineEl)
  }
  // According to Ben's comments in chart.js it is a better way to hide tooltip as the one can be "flacky"
  parent.onmouseleave = function() {
    tooltipEl.style.opacity = 0
    hoverLineEl.style.opacity = 0
  }
  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    // tooltipEl.style.opacity = 0
    // hoverLineEl.style.opacity = 0
    return
  }

  // Set Content
  var title = (tooltip.title || []).join(' ')
  var body = ''

  body = _.map(tooltip.dataPoints || [], function(dataPoint) {
    var meta = data.datasets[dataPoint.datasetIndex]
    var bgColor = tooltip.labelColors[dataPoint.datasetIndex].borderColor
    return renderTemplate(TooltipBodyTemplate, {
      label: meta.label,
      value: dataPoint.yLabel,
      bgColor: bgColor,
    })
  }).join('')

  tooltipEl.innerHTML = renderTemplate(TooltipTemplate, {
    title: title,
    body: body,
  })
  // Make line follow cursor
  hoverLineEl.style.left = tooltip.caretX - 1 + 'px'
  hoverLineEl.style.opacity = 1
  tooltipEl.style.opacity = 0.9
}
